var map = {
	"./1.jpeg": 339,
	"./1price-list-PLEXI__.pdf": 549,
	"./2.jpeg": 6,
	"./2price-list-ETHAR_2024.pdf": 11,
	"./3.jpeg": 325,
	"./3price-list-Ikat-SilkVelvet.pdf": 36,
	"./4.jpeg": 408,
	"./4price-list-LACQUERED2.pdf": 304,
	"./5.jpeg": 279,
	"./5price-list-mother-of-pearl.pdf": 229,
	"./6.jpeg": 986,
	"./6price-list-round-mop-new.pdf": 706,
	"./7.jpeg": 849,
	"./7price-list-Tables.pdf": 432,
	"./Logo.png": 350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;